import React from "react";
import "../css/faq.css";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAPIService } from "./services";

function Faq({ endpoint, params }) {   // <-- endpoint instead of full URL
  const API_URL = `${process.env.REACT_APP_API_DOMAIN}${endpoint}`;
  

  const { result: faqs, loading, error } = useAPIService(API_URL, params);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="faq-outer-wrapper">
      <div className="faq-heading">
        <p>Frequently Asked Questions ?</p>
      </div>
      <Container className="faq-container">
        {faqs && faqs.length > 0 ? (
          faqs.map((faq, index) => (
            <Accordion className="faq-accordion" key={index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  {faq.question || faq.faqTitle || "No question provided"}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {faq.answer || faq.faqDescription || "No answer available"}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <p>No FAQs available</p>
        )}
      </Container>
    </div>
  );
}

export default Faq;
